<template>
  <hm-content title="">
    <div slot="header">
      <hm-step
        :steps="stepName"
        :step="step"
        :disabledFirst="disabledFirst"
        :scroll="true"
        disabledNext
      ></hm-step>
    </div>
    <div v-show="step === 1">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="106px"
      >
        <div class="form-item-tip" v-if="beltType === 'coupon'">
          优惠券腰带目前只支持一个优惠券匹配一个发放规则的情况.
        </div>
        <el-form-item label="腰带预告时间" prop="forecastTime">
          <el-date-picker
            v-model="ruleForm.forecastTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="腰带预告时间"
            size="small"
            class="mr10"
          >
          </el-date-picker>
          <div class="form-item-tip">
            腰带预告时间即为商品详情开始出现腰带的时间，只能早与活动开始时间。
          </div>
        </el-form-item>
        <el-form-item label="腰带优先级" prop="beltPriorityLevel">
          <el-select
            clearable
            size="small"
            v-model="ruleForm.beltPriorityLevel"
            placeholder="请选择腰带优先级"
          >
            <el-option
              :label="item"
              :value="item"
              v-for="item in priorityList"
              :key="item"
            ></el-option>
          </el-select>
          <div class="form-item-tip">
            腰带优先级用于同一个商品存在多条促销腰带情况下使用优先级高的腰带，当优先级相同时则遵循优先使用最新创建的腰带
          </div>
        </el-form-item>
      </el-form>
      <div class="daogou-bder">
        <hm-beltTransfer
          ref="beltTransfer"
          showAttribute
          :beltType="beltType"
        ></hm-beltTransfer>
      </div>
    </div>
    <div v-if="step === 2">
      <div class="mb10 belt-header">
        我的模板
      </div>
      <div class="belt flex flex-wrap ">
        <div
          class="preview pointer"
          :class="{ active: active === v.beltLayoutId }"
          @click="conversion(v)"
          v-for="(v, i) in myBeltList"
          :key="i"
        >
          <img
            v-if="active === v.beltLayoutId"
            class="active-img"
            src="https://imgcdn.hemiao100.com/ThemePictures/1.png"
            alt=""
          />
          <belt
            :backgroundImage="v.backgroundImg"
            :index="v.index"
            :textList="v.textList"
          >
            <div slot="swiper" class="swiper"></div>
          </belt>
          <div class="belt-name">{{ v.templateName }}</div>
        </div>
      </div>
      <!-- <div class="mb10 belt-header">
        系统模板
      </div> -->
      <!-- <div class=" belt flex flex-wrap">
        <div
          class="belt-item pointer belt-box"
          :class="{ active: active === v.beltLayoutId }"
          @click="conversion(v)"
          v-for="(v, i) in beltList"
          :key="i"
        >
          <img
            v-if="active === v.beltLayoutId"
            class="active-img"
            src="https://imgcdn.hemiao100.com/ThemePictures/1%402x.png"
            alt=""
          />
          <div class="ad"></div>
          <div class="belt-temp">
            <img class="bg" :src="v.backgroundImg" alt srcset />
          </div>
          <div class="belt-name">模板{{ i + 1 }}</div>
        </div>
      </div> -->
    </div>
    <div class="btn-wrapper flex flex-center mt20">
      <el-button
        size="small"
        type="primary"
        v-if="step > 1"
        @click="step = step - 1"
        >上一步</el-button
      >
      <el-button
        size="small"
        type="primary"
        v-if="step < 2"
        @click="submitRuleForm('ruleForm')"
        >下一步</el-button
      >
      <el-button
        size="small"
        type="primary"
        v-if="step === 2"
        @click="submitRuleForm('ruleForm')"
        >保存</el-button
      >
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
import belt from "@/components/belt";
import HmBeltTransfer from "@/components/beltTransfer";
export default {
  components: {
    HmStep,
    belt,
    HmBeltTransfer
  },
  data() {
    return {
      backgroundImage: "",
      activeItem: 1,
      beltTemp: {},
      dialogVisibleTest: false,
      isShow: false,
      total: 0,
      currentPageAct: 1,
      pageSizeAct: 10,
      activityList: [],
      rulesList: [],
      searchCondition: {},
      priorityList: [],
      step: 1,
      stepName: [
        {
          name: "腰带规则"
        },
        {
          name: "选择模板"
        }
      ],
      disabledFirst: false,
      ruleForm: {
        forecastTime: "",
        beltPriorityLevel: ""
        // editMode: "automatic",
        // activityTitle: "", //活动规则
        // activitySubtitle: "买到就是赚到", //活动副标题
        // originalPriceTag: "", //原价标签
        // timePriceTag: "限时优惠", //时段标签
        // applyDate: [] //活动时段
      },
      rules: {
        forecastTime: {
          required: true,
          message: "请选择腰带预告时间",
          trigger: "change"
        },
        beltPriorityLevel: {
          required: true,
          message: "请选择腰带优先级",
          trigger: "change"
        },
        activityTitle: {
          required: true,
          message: "请输入活动规则",
          trigger: "change"
        },
        activitySubtitle: {
          required: true,
          message: "请输入活动副标题",
          trigger: "change"
        },
        timePriceTag: {
          required: true,
          message: "请输入时段标签",
          trigger: "change"
        },
        applyDate: {
          required: true,
          message: "请选择活动时段",
          trigger: "change"
        }
      },
      dialogVisible: false,
      checkedRow: {},
      checkedRowGoods: [],
      beltType: "",
      details: {
        basicConfigInfo: {},
        dateConfigInfo: {},
        dateConfigRange: {},
        fullDiscountRule: [],
        pasCalendars: [],
        pasGoods: [],
        pasLabels: [],
        pasOutlets: []
      },
      beltLabel: [],
      inputValue: "",
      inputVisible: false,
      dialogVisibleGoods: false,
      currentMicroPage: 1,
      pageMicroSize: 10,
      searchDialogCondition: {},
      handPriceModelList: [],
      title: "",
      addSaleList: [],
      beltList: [],
      myBeltList: [],
      active: ""
    };
  },
  computed: mapGetters([
    "activityCategoryList",
    "fullDiscountDetails",
    "fullReductionDetails",
    "fullDeliveruDetails",
    "selectType",
    "fullIncreasePurchaseDetails",
    "combinationDetails",
    "specialRuleDetails",
    "microShopGoodsList",
    "tabList"
  ]),
  watch: {},
  created() {
    for (let i = 1; i <= 10; i++) {
      this.priorityList.push(i);
    }
  },
  async mounted() {
    const { result } = await this.$store.dispatch("queryBeltTempList", {
      pageNo: 1,
      pageSize: 9999
    });
    const { records } = result;
    // this.beltList = systemList;

    this.myBeltList = records;
    this.myBeltList.forEach(v => {
      v.index = +v.templateType.replace("model", "");
      v.textList = v.previewComponents ? JSON.parse(v.previewComponents) : [];
    });
  },
  methods: {
    conversion(v) {
      this.active = v.beltLayoutId;
      this.beltTemp = v;
    },
    filterGt0OrFixed2(prop, i) {
      this.handPriceModelList[i][prop] = this.handPriceModelList[i][
        prop
      ].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.handPriceModelList[i][prop] = this.handPriceModelList[i][
        prop
      ].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.handPriceModelList[i][prop] = this.handPriceModelList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.handPriceModelList[i][prop] = this.handPriceModelList[i][
        prop
      ].replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (
        this.handPriceModelList[i][prop].indexOf(".") < 0 &&
        this.handPriceModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.handPriceModelList[i][prop] = parseFloat(
          this.handPriceModelList[i][prop]
        );
      }
    },
    searchGoods() {
      this.currentMicroPage = 1;
      this.queryMicroShopGoodsList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryMicroShopGoodsList() {
      let params = {
        pageSize: this.pageMicroSize,
        pageNo: this.currentMicroPage
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );

      Object.assign(params, searchDialogCondition);

      return this.$store.dispatch("queryMicroShopGoodsList", params);
    },
    pagingMicro(page) {
      this.currentMicroPage = page;
      this.queryMicroShopGoodsList();
    },
    handleSizeMicroChange(size) {
      this.currentMicroPage = 1;
      this.pageMicroSize = size;
      this.queryMicroShopGoodsList();
    },
    // async queryActivityList() {
    //   let params = {
    //     pageNo: this.currentPageAct,
    //     pageSize: this.pageSizeAct
    //   };

    //   const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
    //   searchCondition.startDate =
    //     this.searchCondition.ruleValidDate &&
    //     this.searchCondition.ruleValidDate.length > 0
    //       ? this.searchCondition.ruleValidDate[0]
    //       : "";
    //   searchCondition.endDate =
    //     this.searchCondition.ruleValidDate &&
    //     this.searchCondition.ruleValidDate.length > 0
    //       ? this.searchCondition.ruleValidDate[1]
    //       : "";
    //   let name =
    //     this.beltType === "promotion" ? "queryActivityList" : "getAllBeltRules";
    //   Object.assign(params, searchCondition);
    //   const { result } = await this.$store.dispatch(name, params);

    //   const { records, total } =
    //     this.beltType === "promotion" ? result.activityList : result;
    //   if (this.beltType === "promotion") {
    //     this.activityList = records;
    //   } else if (this.beltType === "coupon") {
    //     this.rulesList = records;
    //   }

    //   this.total = total;
    // },

    submitRuleForm(formName) {
      if (this.step === 1) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            if (this.$refs.beltTransfer.rightData.length > 0) {
              this.beltType = this.$refs.beltTransfer.beltType;
              this.step = 2;
            } else {
              this.$message({
                message: "请选择腰带创建范围!",
                type: "warning"
              });
            }
          } else {
            return false;
          }
        });
      } else if (this.step === 2) {
        if (this.active) {
          let params = this.$refs.beltTransfer.rightData;

          if (this.beltType !== "price") {
            params.forEach(v => {
              v.forecastTime = this.ruleForm.forecastTime;
              v.beltPriorityLevel = this.ruleForm.beltPriorityLevel;
              v.beltLayoutId = this.active;
              v.beltType = this.beltType;
              v.activityStartTime = `${v.startDate} 00:00:00`;
              v.activityEndTime = `${v.endDate} 23:59:59`;
              v.selectId = v.id;
              v.enabledState = "yes";
              v.createTime = "";
            });
          } else {
            params.forEach(v => {
              v.forecastTime = this.ruleForm.forecastTime;
              v.beltPriorityLevel = this.ruleForm.beltPriorityLevel;
              v.beltLayoutId = this.active;
              v.beltType = this.beltType;
              v.enabledState = "yes";
            });
          }
          this.$store.dispatch("addBelt", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.$router.back(-1);
            }
          });
        } else {
          this.$message({
            message: "请选择腰带模板",
            type: "warning"
          });
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}
.belt-header {
  color: #222222;
  font-weight: 700;
  font-size: 16px;
  line-height: 48px;
}
.belt-box {
  // margin: 10px;
  // width: 220px;
  // height: 230px;
  // background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 3px 32px 0px rgba(221, 221, 221, 0.58);
  position: relative;
  .active-img {
    width: 40px;
    height: 40px;
    position: absolute;
    top: 0;
    right: 0;
  }
  // .belt-goodimg {
  //   height: 178px;
  //   background: #ffeaf3;
  // }
}
.caption {
  position: relative;
  padding-left: 10px;
  color: #000;
  margin-bottom: 20px;
  &::before {
    position: absolute;
    left: 0;
    width: 4px;
    height: 100%;
    background: #e50065;
    content: "";
    border-top-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
}
.preview {
  // padding: 10px;
  margin: auto 10px;
  margin-right: 20px;
  width: 375px;
  box-shadow: 0px 3px 32px 0px rgba(221, 221, 221, 0.58);
  margin-bottom: 20px;
  position: relative;
  .active-img {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99999;
  }
  &.active {
    opacity: 0.9;
    color: #e50065;
  }
  .swiper {
    width: 375px;
    height: 375px;
    background: #ffeaf3;
  }
  .belt-temp {
    height: 88px;
  }
  .belt-name {
    padding: 10px;
    text-align: center;
    font-size: 18px;
  }
}
.belt {
  .belt-item {
    background: #fff;
    padding: 10px;
    width: 200px;
    box-shadow: 0px 3px 32px 0px rgba(221, 221, 221, 0.58);
    margin-bottom: 10px;
    &.active {
      opacity: 0.9;
      color: #e50065;
    }
    &:nth-child(n) {
      margin-right: 10px;
    }
    .bg {
      width: 100%;
    }

    .ad {
      position: relative;
      width: 200px;
      height: 200px;
      background: #ffeaf3;
      .belt-temp {
        position: absolute;
        bottom: 0;
        top: 0;
        &.temp2 {
          bottom: 0;
          top: unset;
        }
        img {
          vertical-align: middle;
        }
      }
    }

    .belt-name {
      padding: 10px;
      text-align: center;
      font-size: 12px;
    }
  }
}

.btn.active {
  background: #71abff;
  color: #fff;
  border-radius: 5px;
}
.btn-group {
  margin-bottom: 2rem;
}

.detail-container {
  font-size: 14px;
  .title {
    color: #000;
    margin-right: 20px;
  }
  li {
    margin-bottom: 20px;
  }
  .content {
    > div {
      margin-bottom: 10px;
    }
  }
}
</style>
